<template>
   <svg width="24" height="22" viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg">
     <path d="M19.86 18.66c-2.57 2.58-5.42 3.91-6.36 2.97-.94-.93.4-3.78 2.97-6.36 2.58-2.58 5.43-3.9 6.36-2.97.94.94-.39 3.79-2.97 6.36M18.66 6.66c-2.57 2.58-5.42 3.91-6.36 2.97-.94-.93.4-3.78 2.97-6.36C17.85.7 20.7-.63 21.63.3c.94.94-.39 3.79-2.97 6.36M3.27 13.86c2.58 2.58 5.43 3.91 6.36 2.97.94-.93-.39-3.78-2.97-6.36C4.1 7.9 1.24 6.57.3 7.5c-.94.94.4 3.79 2.97 6.36"/>
   </svg>
</template>

<script>
export default {
   name: 'RiceIcon'
}
</script>